import { parsePreset } from '.';
import dayjs from 'dayjs';

export const periodText = (from: Date, to: Date): string => {
    const preset = parsePreset(from, to);

    if (preset) {
        return preset.label;
    }

    if (!from) {
        return '';
    }

    if (dayjs(from).isSame(to, 'day')) {
        return dayjs(from).format('DD.MM.YYYY');
    }

    return `${ dayjs(from).format('DD.MM.YYYY') } - ${ dayjs(to).format('DD.MM.YYYY') }`;
};
